import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserInfoStorageService {

  userInfo;

  constructor() { }

  storeUserInfo(userInfo) {
    this.userInfo = userInfo;
  }

  clear() {
    this.userInfo = null;
  }
}
